<script lang="ts">
  interface Props {
    size?: 'large' | 'small';
    children?: import('svelte').Snippet;
  }

  let { size = 'large', children }: Props = $props();
</script>

<h1 class:large={size === 'large'} class:small={size === 'small'}>{@render children?.()}</h1>

<style>
  h1 {
    font-family: 'Outfit', sans-serif;
    text-align: center;
    margin: 0;
    font-weight: 200;
    line-height: 1;
  }
  
  h1 :global(span) {
    font-weight: 500;
  }
  
  h1.large {
    font-size: 45px;
    color: var(--primaryText);
    letter-spacing: -2px;
  }

  h1.small {
    font-size: 30px;
    color: var(--primaryText);
    letter-spacing: -1px;
  }
</style>
